import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getApiUrl, API_ENDPOINTS } from "../../config/apiConfig";
import "./BlogSection.css";

const BlogSection = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPublishedBlogs();
  }, []);

  const fetchPublishedBlogs = async () => {
    try {
      setLoading(true);
      // TODO: Replace with your actual API endpoint for published blogs
      const response = await fetch(`${getApiUrl(API_ENDPOINTS.getPublishedBlogs)}?limit=3`);

      if (response.ok) {
        const data = await response.json();
        // Assuming API returns { status: 200, data: [blogs] }
        setBlogs(data.data || []);
      } else {
        // For now, show mock data if API is not ready
        setBlogs(getMockBlogs());
      }
    } catch (error) {
      console.error('Error fetching blogs:', error);
      // Show mock data as fallback
      setBlogs(getMockBlogs());
    } finally {
      setLoading(false);
    }
  };

  // Mock data for demonstration
  const getMockBlogs = () => [
    {
      id: 1,
      title: "Understanding Urology: Common Myths Debunked",
      excerpt: "Learn the truth about common misconceptions in urology and men's health. Discover evidence-based facts about prostate health, urinary issues, and modern treatment approaches.",
      category: "Health Tips",
      featuredImage: null,
      createdAt: "2026-04-03T10:00:00.000Z",
      author: "Dr. Abhinav Singh",
      slug: "understanding-urology-common-myths-debunked"
    },
    {
      id: 2,
      title: "Prostate Health: What Every Man Should Know",
      excerpt: "A comprehensive guide to maintaining optimal prostate health. Learn about screening, lifestyle factors, and when to seek medical attention for prostate concerns.",
      category: "Medical Advice",
      featuredImage: null,
      createdAt: "2026-04-02T15:30:00.000Z",
      author: "Dr. Abhinav Singh",
      slug: "prostate-health-what-every-man-should-know"
    },
    {
      id: 3,
      title: "Advanced Treatment Options in Urology",
      excerpt: "Explore the latest and most effective treatment methods available today. From minimally invasive procedures to cutting-edge technologies in urological care.",
      category: "Treatment",
      featuredImage: null,
      createdAt: "2026-04-01T09:15:00.000Z",
      author: "Dr. Abhinav Singh",
      slug: "advanced-treatment-options-in-urology"
    }
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getCategoryIcon = (category) => {
    const icons = {
      'Health Tips': '📚',
      'Medical Advice': '🏥',
      'Treatment': '💊',
      'Wellness': '🏃',
      'Technology': '💻',
      'Stories': '⭐',
      'Research': '🔬',
      'News': '📰'
    };
    return icons[category] || '📝';
  };

  if (loading) {
    return (
      <section className="blog-section">
        <div className="container">
          <div className="section-header">
            <h2>Latest Health Insights</h2>
            <p>Stay informed with the latest medical knowledge and health tips</p>
          </div>
          <div className="loading-blogs">
            <div className="loading-card"></div>
            <div className="loading-card"></div>
            <div className="loading-card"></div>
          </div>
        </div>
      </section>
    );
  }

  if (blogs.length === 0) {
    return null; // Don't show section if no blogs
  }

  return (
    <section className="blog-section">
      <div className="container">
        <div className="section-header">
          <h2>Latest Health Insights</h2>
          <p>Stay informed with the latest medical knowledge and health tips from Dr. Abhinav Singh</p>
        </div>

        <div className="blogs-grid">
          {blogs.map((blog) => (
            <article key={blog.id} className="blog-card">
              <div className="blog-image">
                {blog.featuredImage ? (
                  <img src={blog.featuredImage} alt={blog.title} />
                ) : (
                  <div className="placeholder-image">
                    {getCategoryIcon(blog.category)}
                  </div>
                )}
                <div className="blog-category">
                  <span>{blog.category}</span>
                </div>
              </div>

              <div className="blog-content">
                <h3>{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>

                <div className="blog-meta">
                  <span className="blog-date">
                    📅 {formatDate(blog.createdAt)}
                  </span>
                  <span className="blog-author">
                    👨‍⚕️ {blog.author}
                  </span>
                </div>

                <Link
                  to={`/blog/${blog.slug}`}
                  className="read-more-btn"
                >
                  Read More →
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="view-all-blogs">
          <Link to="/blogs" className="view-all-btn">
            View All Blogs
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;